export class CatTermModel {
    public iCatTermId?: number;
    public vDescription?: string;
    public iActiveId?: number;
    public vCreateUserId?: string;
    public dtCreateDate?: string;
    public vModifUserId?: string;
    public dtModifDate?: string;
}
